import {
  clearBuyItNowEligibility,
  fetchBuyItNowEligibility,
  fetchCustomerCredits,
  fetchOrderInfo,
  fetchPDPrices
} from "../../actions/index";
import Info from "../components/Info";
import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

const InfoContainer = props => <Info {...props} />;

const mapStateToProps = state => (
  {
    "apiToken": state.apiToken,
    "buyItNowEligible": state.buyItNowEligible,
    "customerId": state.customerId,
    "orderInfo": state.orderInfo,
    "pdPrices": state.pdPrices,
    "warehouseClosed": state.warehouseClosed,
    "warehouseClosedShopPageText": state.warehouseClosedShopPageText
  }
);

export default withRouter(connect(mapStateToProps, {
  clearBuyItNowEligibility,
  fetchBuyItNowEligibility,
  fetchCustomerCredits,
  fetchOrderInfo,
  fetchPDPrices
})(InfoContainer));
